/**
 * 学校服务付费激活系统v1.0.0相关
 * 接口地址http://rap2.10niu.cn/repository/editor?id=21&mod=565
 * 原型https://fbe8gl.axshare.com/#g=1
 */

import requestByGateway from '@/request/request.gateway';
import config from '@/config';
import qs from 'qs';
/* 
  学校服务付费激活系统 
  */
const serveActivate = {
	// 获取学校服务收费列表
	getSchoolServeList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/school-config-fees/v1/list`,
			headers: config.headers,
			params
		});
	},
	// 更新学校收费开关
	updateOpen(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/school-config-fees/v1/update_open`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 设置学校收费
	setSchoolFee(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/school-config-fees/v1/set`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 激活学校收费
	activateSchoolFee(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/school-config-fees/v1/activate`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 取消激活学校收费
	cancelActivateSchoolFee(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/school-config-fees/v1/cancel_activate`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	}
};

export default serveActivate;
